var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2189 16.6951C19.734 11.7445 19.734 6.75378 19.2189 1.80316C19.0578 0.254677 17.2724 -0.529707 16.023 0.399068L11.2535 3.94442C9.75002 5.062 7.92652 5.66551 6.05319 5.66551H1.60268C0.960789 5.66551 0.44043 6.18587 0.44043 6.82776V11.6705C0.44043 12.3124 0.960788 12.8327 1.60268 12.8327L6.05318 12.8327C7.92652 12.8327 9.75002 13.4363 11.2535 14.5538L16.023 18.0992C17.2724 19.028 19.0578 18.2436 19.2189 16.6951Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2189 16.6951C19.734 11.7445 19.734 6.75378 19.2189 1.80316C19.0578 0.254677 17.2724 -0.529707 16.023 0.399068L11.2535 3.94442C9.75002 5.062 7.92652 5.66551 6.05319 5.66551H1.60268C0.960789 5.66551 0.44043 6.18587 0.44043 6.82776V11.6705C0.44043 12.3124 0.960788 12.8327 1.60268 12.8327L6.05318 12.8327C7.92652 12.8327 9.75002 13.4363 11.2535 14.5538L16.023 18.0992C17.2724 19.028 19.0578 18.2436 19.2189 16.6951Z",
    fill: "url(#paint0_linear_47_1546)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73221 15.4114C6.79897 15.1505 6.74142 14.8734 6.57629 14.6607C6.41117 14.448 6.15701 14.3236 5.88774 14.3236L3.56323 14.3236C3.23305 14.3236 2.93122 14.5101 2.78356 14.8054L1.6213 17.1299C1.42282 17.5269 1.55429 18.0096 1.92665 18.2511L4.40687 19.8597C4.64235 20.0124 4.93696 20.0424 5.19839 19.9402C5.45982 19.8381 5.65607 19.6163 5.72566 19.3444L6.73221 15.4114Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73221 15.4114C6.79897 15.1505 6.74142 14.8734 6.57629 14.6607C6.41117 14.448 6.15701 14.3236 5.88774 14.3236L3.56323 14.3236C3.23305 14.3236 2.93122 14.5101 2.78356 14.8054L1.6213 17.1299C1.42282 17.5269 1.55429 18.0096 1.92665 18.2511L4.40687 19.8597C4.64235 20.0124 4.93696 20.0424 5.19839 19.9402C5.45982 19.8381 5.65607 19.6163 5.72566 19.3444L6.73221 15.4114Z",
    fill: "url(#paint1_linear_47_1546)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_1546",
    x1: 9.99881,
    y1: 2.31183,
    x2: 9.99881,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4201FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9954F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_47_1546",
    x1: 9.99881,
    y1: 2.31183,
    x2: 9.99881,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4201FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9954F0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.b357e11a4f65f7cb340eafa88ba600f3.svg";
export { ForwardRef as ReactComponent };